export * from '@primeuix/themes/nora/floatlabel';
export { default } from '@primeuix/themes/nora/floatlabel';
